import { type CSSProperties, type ReactNode } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { CheckSmallIcon } from '@/icons';
import { TextAvatar } from '@/shared/components';
import { DropdownMenuItem } from '@/ui';
import { IconButton } from '@/ui_v3';
import { cn } from '@/utils';
interface ClassroomSelectorAvatarLabelProps {
  text: string;
  textClassName?: string;
  avatarSize: 'xs' | 'sm';
  avatarColorSeed?: string;
  avatarText?: string;
  avatarStyle?: CSSProperties;
  showCheck?: boolean;
}
export function ClassroomSelectorAvatarLabel({
  text,
  textClassName,
  avatarSize,
  avatarColorSeed,
  avatarText,
  avatarStyle,
  showCheck
}: ClassroomSelectorAvatarLabelProps) {
  return <>
      <TextAvatar text={avatarText ?? text} colorSeed={avatarColorSeed} size={avatarSize} className="border border-opacity-assistive" style={avatarStyle} data-sentry-element="TextAvatar" data-sentry-source-file="ClassroomSelectorMenuPrimitives.tsx" />
      <span className={cn('min-w-0 flex-1 truncate text-left', textClassName)}>
        {text}
      </span>
      {showCheck && <CheckSmallIcon size="sm" fill={ICON_COLOR.strong} className="shrink-0" />}
    </>;
}
export function ClassroomSelectorMenuLabel({
  label
}: {
  label: string;
}) {
  return <div className="flex min-h-[32px] w-full items-center rounded-2xs py-2xs" data-sentry-component="ClassroomSelectorMenuLabel" data-sentry-source-file="ClassroomSelectorMenuPrimitives.tsx">
      <span className="min-w-0 flex-1 truncate px-2xs text-caption-lg-semibold text-alternative">
        {label}
      </span>
    </div>;
}
export function ClassroomSelectorMenuItem({
  selected,
  className,
  children,
  onSelect
}: {
  selected?: boolean;
  className?: string;
  children: ReactNode;
  onSelect: () => void;
}) {
  return <DropdownMenuItem className={cn('min-h-[40px] rounded-sm px-2xs py-xs', selected && 'bg-opacity-violet-1', className)} onSelect={onSelect} data-sentry-element="DropdownMenuItem" data-sentry-component="ClassroomSelectorMenuItem" data-sentry-source-file="ClassroomSelectorMenuPrimitives.tsx">
      <span className="flex w-full items-center gap-2xs text-body-sm-medium text-default">
        {children}
      </span>
    </DropdownMenuItem>;
}
export function ClassroomSelectorManageItem({
  label,
  icon,
  onSelect
}: {
  label: string;
  icon: ReactNode;
  onSelect: () => void;
}) {
  return <ClassroomSelectorMenuItem onSelect={onSelect} data-sentry-element="ClassroomSelectorMenuItem" data-sentry-component="ClassroomSelectorManageItem" data-sentry-source-file="ClassroomSelectorMenuPrimitives.tsx">
      <IconButton asChild variant="outlined" intent="neutral" size="xs" rounded="full" className="shrink-0" data-sentry-element="IconButton" data-sentry-source-file="ClassroomSelectorMenuPrimitives.tsx">
        <span aria-hidden="true">{icon}</span>
      </IconButton>
      <span className="flex-1 truncate text-left text-body-sm-semibold text-neutral">
        {label}
      </span>
    </ClassroomSelectorMenuItem>;
}